import React, { useContext, useEffect, useRef, useState } from "react";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import Constant from "../../Constants";
import AmericanExpressBrand from "../../svg/AmericanExpressBrand";
import Diners from "../../svg/Diners";
import DiscoverBrand from "../../svg/DiscoverBrand";
import EftPos from "../../svg/EftPos";
import Girocard from "../../svg/Girocard";
import JcbBrand from "../../svg/JcbBrand";
import MasterCardBrand from "../../svg/MasterCardBrand";
import UnionPayBrand from "../../svg/UnionPayBrand";
import VisaBrand from "../../svg/VisaBrand";
import Unknown from "../../svg/Unknown";
import BlueBg from "../../svg/BlueCardBg";
import RedBg from "../../svg/RedCardBg";
import GreenBg from "../../svg/GreenCardBg";
import YellowBg from "../../svg/YellowCardBg";
import OrangeBg from "../../svg/OrangeCardBg";
import LeftIcon from "../../svg/LeftIcon";
import RightIcon from "../../svg/RightIcon";
import axiosInstance from "../../../utils/Requests/axios";
import UserContext from "../../../utils/Contexts/UserContext";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import AddCardBg from "../../svg/AddCardBg";
import AddCardModal from "../../../modals/AddCardModal";
import RightArrow from "../../svg/RightArrow";

function AccountCards() {
  const { t } = useContext(LanguageContext);
  const { themeStatus } = Constant();
  const { selectedTheme } = useContext(ThemeContext);
  const { userData } = useContext(UserContext);
  const [cards, setCards] = useState([]);
  const navigate = useNavigate();

  const cardBrandConfig = {
    0: { label: "Unknown", Icon: Unknown, brandBg: OrangeBg },
    1: {
      label: "American Express",
      Icon: AmericanExpressBrand,
      brandBg: GreenBg,
    },
    2: { label: "Diners Club", Icon: Diners, brandBg: BlueBg },
    3: { label: "Discover", Icon: DiscoverBrand, brandBg: YellowBg },
    4: { label: "Eftpos Australia", Icon: EftPos, brandBg: RedBg },
    5: { label: "Girocard", Icon: Girocard, brandBg: BlueBg },
    6: { label: "JCB", Icon: JcbBrand, brandBg: RedBg },
    7: { label: "MasterCard", Icon: MasterCardBrand, brandBg: YellowBg },
    8: { label: "UnionPay", Icon: UnionPayBrand, brandBg: OrangeBg },
    9: { label: "Visa", Icon: VisaBrand, brandBg: BlueBg },
  };

  const addedCardsFetched = useRef(false);
  const getAddedCards = () => {
    if (addedCardsFetched.current) return;
    addedCardsFetched.current = true;
    const url = `/users/${userData?.uuid}/cards`;
    axiosInstance
      .get(url)
      .then((response) => {
        setCards(response?.data);
      })
      .catch(() => {
        toast.error(t("There was an error fetching the saved cards data"));
      });
  };

  useEffect(() => {
    getAddedCards();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const nextCard = () => {
    setCards((prev) => {
      const newCards = [...prev];
      const first = newCards.shift();
      newCards.push(first);
      return newCards;
    });
  };

  const prevCard = () => {
    setCards((prev) => {
      const newCards = [...prev];
      const last = newCards.pop();
      newCards.unshift(last);
      return newCards;
    });
  };

  const navigateToCards = () => {
    const url = `/user/settings#SavedCards`;
    navigate(url);

    setTimeout(() => {
      const offersSection = document.getElementById("SavedCards");
      if (offersSection) {
        const headerOffset =
          document.getElementById("header")?.offsetHeight || 80;
        const sectionPosition =
          offersSection.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = sectionPosition - headerOffset - 20;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }, 1200);
  };

  return (
    <div
      className={`position-relative w-100 p-4 cardSetting rounded overflow-hidden custom-height-cards ${themeStatus?.[selectedTheme]}`}
      style={{ backgroundColor: "var(--bg-card)" }}
    >
      <div className="d-flex justify-content-between mb-2">
        <h4 className="card-title p-0">{t("Accounts and Cards")}</h4>
        <p
          className="card-text cursor-pointer d-flex align-items-center manage-cards text-primary"
          onClick={() => navigateToCards()}
        >
          {t("Manage Cards")} <RightArrow />
        </p>
      </div>
      <div
        className="mb-3"
        style={{
          borderBottom: `2px solid var(--border)`,
          marginLeft: "-30px",
          marginRight: "-30px",
        }}
      ></div>
      <div className="position-relative">
        {cards?.length > 0 ? (
          cards?.map((card, index) => {
            const brandData =
              cardBrandConfig[card?.brand] || cardBrandConfig[0];
            const Background = brandData.brandBg;
            const CardIcon = brandData.Icon;
            const shadow = `0px 4px 12px rgba(0, 0, 0, 0.6)`;

            return (
              <div
                key={card?.uuid || index}
                className="position-absolute transition-all d-flex flex-column align-items-center justify-content-between text-white"
                style={{
                  left: `${index * 22}px`,
                  zIndex: 90 - index,
                  transform: `scale(${1 - index * 0.04})`,
                  transition:
                    "left 0.4s ease-in-out, transform 0.4s ease-in-out",
                  pointerEvents: index === 0 ? "auto" : "none",
                  borderRadius: "1rem",
                  overflow: "hidden",
                  boxShadow: shadow,
                }}
              >
                <Background />
                <div
                  style={{
                    position: "absolute",
                    top: "1rem",
                    left: "1rem",
                    zIndex: 2,
                  }}
                >
                  <CardIcon fill="#ffffff" />
                </div>
                <div
                  className="card-info-balance"
                  style={{
                    position: "absolute",
                    bottom: "3rem",
                    left: "1rem",
                    zIndex: 2,
                  }}
                >
                  xxxx xxxx xxxx {card?.last4}
                </div>
                <div
                  className="card-expiry-balance"
                  style={{
                    position: "absolute",
                    bottom: "1rem",
                    left: "1rem",
                    zIndex: 2,
                  }}
                >
                  {card?.exp_month}/{card?.exp_year}
                </div>
                {card?.primary && (
                  <div
                    style={{
                      position: "absolute",
                      top: "1rem",
                      right: "1rem",
                      zIndex: 3,
                      color: "white",
                      fontSize: "1rem",
                      fontWeight: "bold",
                    }}
                  >
                    {t("Primary")}
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div
            className="d-flex flex-column align-items-center justify-content-center text-white"
            style={{
              position: "relative",
              borderRadius: "1rem",
              overflow: "hidden",
              width: "100%",
              height: "100%",
              textAlign: "center",
            }}
          >
            <AddCardBg />
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <p className="no-card-msg mb-0">{t("You don’t have any card")}</p>
              <button
                data-bs-toggle="modal"
                data-bs-target="#modalAddCard"
                className="btn btn-outline-primary btn-add-card p-0 d-flex align-items-center justify-content-center"
              >
                {t("Add a Card")}
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Arrows at Bottom Right */}
      {cards?.length > 0 && (
        <div
          className="d-flex justify-content-end gap-2 mt-0"
          style={{
            position: "absolute",
            bottom: "0.8rem",
            right: "1rem",
            zIndex: 95,
          }}
        >
          <button
            className="btn btn-sm btn-light align-items-center p-0"
            style={{ width: "30px", height: "30px" }}
            onClick={prevCard}
          >
            <LeftIcon />
          </button>
          <button
            className="btn btn-sm btn-light align-items-center p-0"
            style={{ width: "30px", height: "30px" }}
            onClick={nextCard}
          >
            <RightIcon />
          </button>
        </div>
      )}
      <AddCardModal />
    </div>
  );
}

export default AccountCards;
